import {
  getAllCategories,
  getAllBrands,
  getAllFamilies,
  getAllSubFamiliesByFamilyId,
  getAllCategoriesBySubFamilyId,
  getProductById,
} from "../../reduxSaga/actions";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { useSelector, useDispatch } from "react-redux";
import AddBrand from "../../ui/AddBrand";
import { addNewProduct } from "../../reduxSaga/actions";
import { BlockPicker } from "react-color";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import RichTextEditor from "../../components/ui/RichTextEditor";
import { isEmptyHtml, toEditorHtml } from "../../utils/richText";
import AddCategory from "../../ui/AddCategory";
import AddFamily from "../../ui/AddFamily";
import AddSubFamily from "../../ui/AddSubFamily";
import ConfirmAddProduct from "../../ui/ConfirmAddProduct";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";
import "./AddProductStyle.css";
import $ from "jquery";
import SpecificityService from "../../services/SpecificityService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import DataTableSpecificity from "../../ui/DataTableSpecificity";
import UploadAndDownloadService from "../../services/uploadAndDownloadFile";
import { useNavigate } from "react-router-dom";
import { productImageSrc, onProductImageError } from "../../utils/productImage";

const UpdateProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const availableBrands = useSelector((state) => state.staff.availableBrands);
  const availableFamilies = useSelector(
    (state) => state.staff.availableFamilies
  );
  const availableSubFamilies = useSelector(
    (state) => state.staff.availableSubFamilies
  );

  const availableCategories = useSelector(
    (state) => state.staff.availableCategories
  );
  const availableProduct = useSelector((state) => state.staff.availableProduct);

  const [brandId, setBrandId] = useState();
  const [libelleColor, setLibelleColor] = useState("");
  const [descriptionSpecificity, setDescriptionSpecificity] = useState("");

  const [background, setBackground] = useState("#FF5733");
  const [specificities, setSpecificities] = useState([]);

  const [productName, setProductName] = useState("");
  const [typeCategory, setTypeCategory] = useState(0);

  const [productBarCode, setProductBarCode] = useState("");
  const [productCodeArticle, setProductCodeArticle] = useState("");

  const [productInitialPrice, setProductInitialPrice] = useState(0);
  const [productMinStock, setProductMinStock] = useState(0);
  const [productOptimalStock, setProductOptimalStock] = useState(0);

  const [productDesc, setProductDesc] = useState("");
  // second language (English) of the label and the description
  const [productNameEn, setProductNameEn] = useState("");
  const [productDescEn, setProductDescEn] = useState("");
  const [languageTab, setLanguageTab] = useState("fr"); // "fr" | "en"
  const [productTva, setCategoryTva] = useState(0);
  const [familyId, setFamilyId] = useState(0);
  const [familyName, setFamilyName] = useState(null);

  const [categorieSellingPrice, setCategorySellingPrice] = useState(0);
  const [subFamilyName, setSubFamilyName] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  const [categoryId, setCategoryId] = useState(0);
  const [subFamilyId, setSubFamilyId] = useState(0);
  const [onAddBrand, setOnAddBrand] = useState(false);
  const [onAddCategory, setOnAddCategory] = useState(false);
  const [onAddFamily, setOnAddFamily] = useState(false);
  const [onAddSubFamily, setOnAddSubFamily] = useState(false);
  const [onConfirmAddProduct, setOnConfirmAddProduct] = useState(false);
  const [confirmProductModel, setConfirmProductModel] = useState();
  const [availableSpecificity, setAvailableSpecificity] = useState([]);
  const [specifityChoosen, setSpecifityChoosen] = useState([]);
  const [specifityById, setSpecifityById] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [specificitySelectPlaceHolder, setSpecificitySelectPlaceHolder] =
    useState("Choisir une spécificité produits");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [selectedOption, setSelectedOption] = useState(null);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [myProductModel, setMyProductModel] = useState({});
  const [product, setProduct] = useState();
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [typeSpecificity, setTypeSpecificity] = useState("");
  const [specificityTableData, setSpecificityTableData] = useState([]);
  const [showListSpecificity, setShowListSpecificity] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const animatedComponents = makeAnimated();
  useEffect(() => {
    const idProduct = sessionStorage.getItem("idProduct");
    if (!idProduct) {
      setLoadError(true);
      setLoading(false);
    } else {
      ProductService.getProductById(getCurrentUserId(), idProduct)
        .then((response) => {
          const loaded = response.data["Product"];
          if (!loaded) {
            setLoadError(true);
            return;
          }
          setProduct(loaded);
          setProductName(loaded.name);
          setProductDesc(toEditorHtml(loaded.description));
          setProductNameEn(loaded.nameEn || "");
          setProductDescEn(toEditorHtml(loaded.descriptionEn));
          setTypeCategory(loaded.category.type);
          SpecificityService.getProductSpecificityByCategory(
            getCurrentUserId(),
            loaded.category.id
          ).then((responseSpecificite) => {
            setAvailableSpecificity(responseSpecificite.data);
          });
        })
        .catch(() => setLoadError(true))
        .finally(() => setLoading(false));
    }

    dispatch(getAllFamilies(0));
    dispatch(getAllBrands(0));
  }, []);
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  useEffect(() => {
    availableFamilies &&
      availableFamilies.map((element, i) => {
        if (i === 0) {
          setFamilyId(element.id);
        }
      });
  }, [availableFamilies]);
  useEffect(() => {
    setSpecificities([]);

    availableSpecificity &&
      availableSpecificity.map((element, i) => {
        setSpecificities((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableSpecificity]);

  useEffect(() => {
    familyId && dispatch(getAllSubFamiliesByFamilyId(familyId));
  }, [familyId]);

  useEffect(() => {
    if (availableSubFamilies.length === 0) {
      setSubFamilyId(0);
      setCategoryId(0);
    }
    availableSubFamilies &&
      availableSubFamilies.map((element, i) => {
        if (i === 0) {
          setSubFamilyId(element.id);
        }
      });
  }, [availableSubFamilies]);

  useEffect(() => {
    subFamilyId && dispatch(getAllCategoriesBySubFamilyId(subFamilyId));
  }, [subFamilyId]);

  useEffect(() => {
    if (availableCategories.length === 0) {
      setCategoryId(0);
    }
    availableCategories &&
      availableCategories.map((element, i) => {
        if (i === 0) {
          setCategoryId(element.id);
        }
      });
  }, [availableCategories]);

  useEffect(() => {
    availableBrands &&
      availableBrands.map((element, i) => {
        if (i === 0) {
          setBrandId(element.id);
        }
      });
  }, [availableBrands]);

  const onChangeNameHandler = (event) => {
    setProductName(event.target.value);
  };
  const onChangeValueHandler = (event) => {
    setBackground(event.target.value);
  };
  const handleChangeComplete = (color, event) => {
    setBackground(color.hex);
  };
  const changeLibelleSpecificityHandler = (event) => {
    setLibelleColor(event.target.value);
  };
  const changeDescriptionSpecificityHandler = (event) => {
    setDescriptionSpecificity(event.target.value);
  };

  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };

  const onChangeMinStockHandler = (event) => {
    setProductMinStock(event.target.value);
  };
  const onChangeOptimalStockHandler = (event) => {
    setProductOptimalStock(event.target.value);
  };
  const onChangeDescriptionHandler = (event) => {
    setProductDesc(event.target.value);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onChangeSelected = (selectedOption) => {
    setSelectedOption();
    setSpecifityChoosen(selectedOption.value);
    setSpecificitySelectPlaceHolder(selectedOption.label);
    setTypeSpecificity(selectedOption.customElements);
  };
  const onAddSpecificityToList = (event) => {
    if (specifityChoosen === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un produit ");
    } else {
      setSpecifityById((previoustate) => [
        ...previoustate,
        {
          name: libelleColor,
          idProductSpecificity: specifityChoosen,
          value: background,
          description: descriptionSpecificity,
          type: typeSpecificity,
        },
      ]);
      setSpecificityTableData((previoustate) => [
        ...previoustate,
        {
          name: libelleColor,
          idProductSpecificity: specifityChoosen,
          value: background,
          description: descriptionSpecificity,
          type: typeSpecificity,
        },
      ]);
    }
  };
  const showSaveError = (text) => {
    setSaving(false);
    setOpenErrorAlert(true);
    setErrorAlertText(text);
  };
  const saveProduct = (imagePath) => {
    const productModel = {
      idProduct: sessionStorage.getItem("idProduct"),
      minimumQuantity: productMinStock,
      name: productName,
      description: productDesc,
      nameEn: productNameEn.trim(),
      descriptionEn: isEmptyHtml(productDescEn) ? "" : productDescEn,
      idUserCreation: getCurrentUserId(),
      optimalStock: productOptimalStock,
      specificities: specificityTableData,
    };
    if (imagePath) productModel.imagePath = imagePath;
    ProductService.addMarketingProduct(productModel)
      .then((resultMerketing) => {
        if (resultMerketing.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/products`);
          }, 2000);
        } else {
          showSaveError("Erreur :erreur serveur ");
        }
      })
      .catch(() => showSaveError("Erreur : il ya un probléme de connection"));
  };
  const onConfirmAddProductMarketingHandler = (event) => {
    if (saving) return;
    if (!productName || productName.trim() === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : le libellé est obligatoire");
      setLanguageTab("fr");
      return;
    }
    if (isEmptyHtml(productDesc)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la description est obligatoire");
      setLanguageTab("fr");
      return;
    }
    if (isEmptyHtml(productDescEn) !== (productNameEn.trim() === "")) {
      // the English version is optional but must be complete: label and description together
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : renseignez le libellé et la description anglais, ou aucun des deux");
      setLanguageTab("en");
      return;
    }
    setSaving(true);
    if (file !== null) {
      const uploadData = new FormData();
      uploadData.append("picture", file);
      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadFile/ProductPicture",
        uploadData
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            saveProduct(response.data.success);
          } else {
            showSaveError("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => showSaveError("Erreur : il ya un probléme de connection"));
    } else {
      saveProduct();
    }
  };
  const blocSpecificity = () => {
    if (typeSpecificity === 1) {
      return (
        <div className="row">
          <div className="col-md-4">
            <label>Libellé:</label>
            <input
              type="libelle"
              className="form-control"
              placeholder="Ajouter libellé"
              value={libelleColor}
              onChange={changeLibelleSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Description:</label>
            <input
              type="description"
              className="form-control"
              placeholder="Ajouter description"
              value={descriptionSpecificity}
              onChange={changeDescriptionSpecificityHandler}
            />
          </div>

          <div className="col-md-4">
            <label>Choisir la couleur : </label>
            <BlockPicker
              color={background}
              onChangeComplete={handleChangeComplete}
            />
          </div>
          <div className="form-group" class="col-sm-4 ">
            <button
              style={{ marginTop: 20, marginBottom: 20 }}
              class="btn btn-dark  float-right"
              onClick={onAddSpecificityToList}
            >
              <i class="fas fa-plus"></i>
              Liste des spécificitées{" "}
            </button>
          </div>
        </div>
      );
    } else if (typeSpecificity === 0) {
      return (
        <div className="row">
          <div className="col-md-4">
            <label>Libellé:</label>
            <input
              type="libelle"
              className="form-control"
              placeholder="Ajouter libellé"
              value={libelleColor}
              onChange={changeLibelleSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Description:</label>
            <input
              type="description"
              className="form-control"
              placeholder="Ajouter Description"
              value={descriptionSpecificity}
              onChange={changeDescriptionSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Valeur:</label>
            <input
              type="valeur"
              className="form-control"
              placeholder="Ajouter libellé"
              value={background}
              onChange={onChangeValueHandler}
            />
          </div>

          <div className="form-group" class="col-sm-4 ">
            <button
              style={{ marginTop: 20, marginBottom: 20 }}
              class="btn btn-dark  float-right"
              onClick={onAddSpecificityToList}
            >
              <i class="fas fa-plus"></i>
              Liste des spécificitées{" "}
            </button>
          </div>
        </div>
      );
    }
  };
  const blocStockMin = () => {
    if (typeCategory === 2) {
      return (
        <div className="col-sm-4">
          {() => {
            setProductMinStock(0);
          }}
        </div>
      );
    } else {
      return (
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="inputProjectLeader"> Stock minimal</label>
            <input
              onChange={onChangeMinStockHandler}
              type="number"
              min="0"
              id="inputProjectLeader"
              className="form-control"
            />
          </div>
        </div>
      );
    }
  };
  const blocStockOptimal = () => {
    if (typeCategory === 2) {
      return (
        <div className="col-sm-4">
          {() => {
            setProductOptimalStock(0);
          }}
        </div>
      );
    } else {
      return (
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="inputProjectLeader"> Stock optimal</label>
            <input
              onChange={onChangeOptimalStockHandler}
              type="number"
              min="0"
              id="inputProjectLeader"
              className="form-control"
            />
          </div>
        </div>
      );
    }
  };
  const columns = [
    {
      dataField: "name",
      text: "Libellé",
    },
    {
      dataField: "value",
      text: "Valeur",
    },
    {
      dataField: "description",
      text: "Description",
    },
  ];
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-pencil-alt mr-2"></i>Compléter le produit
              </h4>
              <small className="text-muted">
                Renseignez le libellé, la description, l'image et les
                spécificités du produit
              </small>
            </div>
            <button
              className="btn btn-outline-dark mt-2 mt-sm-0"
              onClick={() => navigate("/products")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux produits
            </button>
          </div>
        </div>
      </section>
      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-dark" role="status">
            <span className="sr-only">Chargement...</span>
          </div>
          <div className="text-muted mt-2">Chargement du produit...</div>
        </div>
      )}
      {!loading && loadError && (
        <div className="container-fluid">
          <div className="alert alert-warning">
            Produit introuvable. Retournez à la liste des produits et
            sélectionnez un produit.
          </div>
        </div>
      )}
      {product && (
        <section className="content ">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="card card-outline card-dark"
                  style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
                >
                  <div className="card-header">
                    <h5 className="card-title">
                      <i className="fas fa-box mr-2"></i>
                      {product.productCode || product.name}
                    </h5>
                  </div>

                  <div className="card-body">
                    <ul className="nav nav-tabs mb-3">
                      {[
                        { key: "fr", label: "Français", done: productName.trim() !== "" && !isEmptyHtml(productDesc) },
                        { key: "en", label: "Anglais", done: productNameEn.trim() !== "" && !isEmptyHtml(productDescEn) },
                      ].map((tab) => (
                        <li className="nav-item" key={tab.key}>
                          <button
                            type="button"
                            className={"nav-link" + (languageTab === tab.key ? " active" : "")}
                            onClick={() => setLanguageTab(tab.key)}
                          >
                            {tab.label}{" "}
                            <span
                              title={tab.done ? "Complet" : "À compléter"}
                              style={{
                                display: "inline-block",
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                background: tab.done ? "#28a745" : "#ffc107",
                              }}
                            />
                          </button>
                        </li>
                      ))}
                    </ul>
                    {languageTab === "fr" ? (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="inputName">Libellé</label>
                              <input
                                onChange={onChangeNameHandler}
                                type="text"
                                id="inputName"
                                value={productName}
                                placeholder={product.name}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="inputDescription">Description</label>
                              <RichTextEditor
                                id="inputDescription"
                                value={productDesc}
                                onChange={setProductDesc}
                                placeholder="Description du produit"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="inputNameEn">Libellé (anglais)</label>
                              <input
                                onChange={(e) => setProductNameEn(e.target.value)}
                                type="text"
                                id="inputNameEn"
                                maxLength={255}
                                value={productNameEn}
                                placeholder="Product name"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="inputDescriptionEn">Description (anglais)</label>
                              <RichTextEditor
                                id="inputDescriptionEn"
                                value={productDescEn}
                                onChange={setProductDescEn}
                                placeholder="Product description"
                              />
                              <small className="text-muted">
                                Facultatif : renseignez le libellé et la description ensemble, ou laissez vide.
                              </small>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div
                            class="input-group   sm-white border"
                            style={{ marginTop: 60 }}
                          >
                            <input
                              id="upload"
                              type="file"
                              accept=".jpg, .jpeg, .png"
                              className="form-control border-0"
                              onChange={onUploadImageHandler}
                            />

                            <label
                              id="upload-label"
                              for="upload"
                              class="font-weight-light text-muted"
                            >
                              {fileName}
                            </label>
                            <div class="input-group-append">
                              <label
                                for="upload"
                                class="btn btn-light m-0 rounded-pill px-4"
                              >
                                {" "}
                                <i class="fa fa-cloud-upload text-muted"></i>
                                <small class="text-uppercase font-weight-bold text-muted">
                                  Choisir une image
                                </small>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div
                            class="image-area"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <img
                              id="imageResult"
                              src={fileDataURL || productImageSrc(product.imagePath)}
                              onError={onProductImageError}
                              alt={product.name}
                              style={{ maxHeight: 197, maxWidth: "100%", objectFit: "contain" }}
                              className="img-fluid rounded shadow-sm mx-auto d-block"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Choisir une spécificité</label>
                          <Select
                            styles={styles}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={selectedOption}
                            onChange={onChangeSelected}
                            options={specificities}
                            placeholder={specificitySelectPlaceHolder}
                            menuPlacement={"top"}
                          />
                        </div>
                      </div>
                    </div>
                    {blocSpecificity()}
                    {specificityTableData && (
                      <ToolkitProvider
                        keyField="id"
                        data={specificityTableData}
                        columns={columns}
                      >
                        {(props) => (
                          <div>
                            <div className="row">
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </div>

                  <div class="card-footer">
                    <button
                      className="btn btn-dark float-right"
                      onClick={onConfirmAddProductMarketingHandler}
                      disabled={saving}
                    >
                      {saving ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Enregistrement...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check mr-1"></i>
                          Confirmer
                        </>
                      )}
                    </button>
                    <button
                      className="btn btn-outline-secondary float-right mr-2"
                      onClick={() => navigate("/products")}
                      disabled={saving}
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <div class="col-sm-10"> </div>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
      {onAddSubFamily && (
        <AddSubFamily
          familyId={familyId}
          setOnAddSubFamily={setOnAddSubFamily}
        />
      )}
      {onAddFamily && <AddFamily setOnAddFamily={setOnAddFamily} />}
      {onAddBrand && <AddBrand setOnAddBrand={setOnAddBrand} />}
      {onAddCategory && (
        <AddCategory
          familyId={familyId}
          subFamilyId={subFamilyId}
          setOnAddCategory={setOnAddCategory}
        />
      )}
      {onConfirmAddProduct && (
        <ConfirmAddProduct
          setOnConfirmAddProduct={setOnConfirmAddProduct}
          confirmProductModel={confirmProductModel}
          setMyProductModel={setMyProductModel}
        />
      )}
    </div>
  );
};
export default UpdateProduct;
